import React, { ReactElement, ChangeEvent, useState } from "react";
import { groupIcon, personalIcon } from "../../../shared/icons";
import styles from "./CustomRadio.module.scss";

interface CustomRadioProps {
    name: string;
    options: any[];
    handleChange: (e: ChangeEvent) => void;
    groupTraining?: boolean
}

const CustomRadio = (props: CustomRadioProps): ReactElement => {

    const defaultChecked = props.options.find(x => x.defaultChecked);
    const firstIndex = props.options.indexOf(defaultChecked);
    const [current, setCurrent] = useState<number>(firstIndex);

    return (
        <>
            {!props.groupTraining &&
                <p className={styles.communicationTitle}>Select your preferred method of communication :* </p>
            }
            <div className={`${styles.radioWrapper} ${props.groupTraining ? "" : styles.preferredMethod}`}>
                {props.options.map((option, i: number) => (
                    <button
                        key={i}
                        type="button"
                        className={`${styles.inputCta} ${i === current ? styles.active : ""}`}
                        onPointerDown={() => setCurrent(i)}
                    >
                        <input
                            type="radio"
                            name={props.name}
                            onChange={props.handleChange}
                            value={option.value}
                            className={styles.radioCta}
                            defaultChecked={option.defaultChecked}
                        />
                        <span className={`${styles.labelCta} ${props.groupTraining ? styles.showSvg : " "}`}>{i === 0 ? personalIcon : groupIcon} {option.label}</span>
                    </button>
                ))}
            </div>
        </>
    );
};
export default CustomRadio;
